export const facebook_auth_id = process.env.REACT_APP_FACEBOOK_AUTH_ID

export const google_auth_id = process.env.REACT_APP_GOOGLE_AUTH_ID
